// Generated by ts-to-zod
import { z } from 'zod';

export const emailThreadPatchPayloadSchema = z.object({
  hasNewReplies: z.boolean().optional(),
  rootEmailRead: z.boolean().optional(),
});
